/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import AddOrUpdateModel from "../GenericComponents/AddOrUpdateModel";
import AutomaticCost from "./AutomaticCost";
import { CostModel } from "../../Utils/Models";
import { Tab, Tabs } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import ItemList from "./ItemList";

type CustomerMainPageProps = {
  item: any;
  open: boolean;
  onClose: () => void;
  title?: string;
};
export default function AutomaticCostPage(props: CustomerMainPageProps) {
  const { item, open, onClose, title } = props;
  const ref: any = useRef();
  const [pressOnSubmit, setPressOnSubmit] = useState(false);
  const [manualCost, setManualCost] = useState(new CostModel());
  const [file, setFile] = useState<File | undefined>();
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (item) {
      setManualCost(item);
    }
  }, [item]);

  function handleChangeValue(event: React.SyntheticEvent, newValue: number) {
    setValue(newValue);
  }

  /**
   *
   */
  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      //reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  /**
   *
   */
  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }

  function showInformation() {
    switch (value) {
      case 0:
        return (
          <AutomaticCost
            manualCost={manualCost}
            setManualCost={setManualCost}
            setFile={setFile}
            file={file}
          />
        );
      case 1:
        return <ItemList items={manualCost.items} />;
      default:
        break;
    }
  }

  return (
    <ValidatorForm
      ref={ref}
      onSubmit={() => {
        ("");
      }}
    >
      <AddOrUpdateModel
        open={open}
        title={title || ""}
        onClose={onClose}
        isSubmit={true}
        addOrUpdateItem={() => null}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
      >
        <Tabs value={value} onChange={handleChangeValue} textColor="inherit">
          <Tab label={Vocabulary.invoice} />
          <Tab label={Vocabulary.items} />
        </Tabs>
        {showInformation()}
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
